module.exports = __webpack_public_path__ + "img/dictionary-img.4ede9855.svg";